const SectionHead = ({ eyebrow, title, sub, align = "center", dark = false, testId }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testId}>
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <h2
      className={`mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight ${
        dark ? "text-[#F5F2EB]" : "text-[#3E2723]"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-[#E7DED2]/80" : "text-[#5D4037]"}`}>
        {sub}
      </p>
    )}
  </div>
);

export default SectionHead;
